<div class="api-card">
  <div class="api-card__header">
    <div class="api-card__header-stack">
      <span class="api-card__title">Organizations</span>
      <span class="api-card__desc">All organizations on the platform.</span>
    </div>
  </div>


  <div class="admin-table-scroll">
    <table class="billing-table admin-stack admin-stack--orgs-preview">
      <thead>
        <tr>
          <th>Organization</th>
          <th>Billing</th>
          <th class="col-num">Balance</th>
        </tr>
      </thead>
      <tbody>
        @if (isLoading) {
          @for (i of [1,2,3,4]; track i) {
            <tr>
              <td><app-skeleton width="70%" height="14px"></app-skeleton></td>
              <td><app-skeleton width="60px" height="20px" radius="4px"></app-skeleton></td>
              <td><app-skeleton width="70px" height="14px"></app-skeleton></td>
            </tr>
          }
        } @else {
          @for (row of rows; track row.slug) {
            <tr>
              <td>{{ row.name }}</td>
              <td>
                @if (row.billingExempt) {
                  <span class="txn-kind-badge txn-kind-badge--neutral">Exempt</span>
                } @else {
                  Billed
                }
              </td>
              <td class="col-num" [class.billing-card__balance--negative]="row.balanceCents < 0">
                {{ row.balanceCents | money }} {{ row.currency | uppercase }}
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>

  <div class="api-card__footer">
    <a routerLink="/admin/organizations" class="link">
      View all organizations
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M4.5 2.5L8 6L4.5 9.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </a>
  </div>
</div>
